
import { defineComponent, computed, ref, PropType, onMounted, watch, nextTick } from "vue-demi";
import { formatNumber } from "@/utils/formatter";

type Tab = {
  title: string;
  subtitle?: string;
  count?: number;
};

export default defineComponent({
  name: "TabsSlider",

  props: {
    selectedTab: {
      type: Number,
      required: true,
    },
    tabs: {
      type: Array as PropType<Tab[]>,
      required: true,
    },
    stretch: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String as PropType<"frame" | "underline">,
      default: "frame",
    },
    hideEmpty: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:selectedTab"],

  setup(props) {
    const tabRefs = ref<HTMLElement[]>([]);
    const indicatorLeft = ref(0);
    const indicatorWidth = ref(0);

    const updateIndicator = () => {
      const el = tabRefs.value[props.selectedTab];

      if (el) {
        indicatorLeft.value = el.offsetLeft;
        indicatorWidth.value = el.offsetWidth;
      }
    };

    onMounted(() => {
      nextTick(updateIndicator);
    });

    watch(
      () => props.selectedTab,
      () => {
        nextTick(updateIndicator);
      }
    );

    watch(
      () => props.tabs,
      () => {
        nextTick(updateIndicator);
      }
    );

    const indicatorStyle = computed(() => ({
      transform: `translateX(${indicatorLeft.value}px)`,
      width: `${indicatorWidth.value}px`,
    }));

    const counterNumber = (tab: Tab) => {
      if (!tab || typeof tab.count !== "number") return null;

      if (props.hideEmpty && tab.count == 0) return null;

      return formatNumber(tab.count);
    };

    return {
      tabRefs,
      indicatorStyle,
      formatNumber,
      counterNumber,
    };
  },
});
